export default {
  "配置": {
    "title": "Global",
    "url": "#全局配置",
    "sub": {
      "silent": "#silent",
      "optionMergeStrategies": "#optionMergeStrategies",
      "devtools": "#devtools",
      "errorHandler": "#errorHandler",
      "warnHandler": "#warnHandler@2.4",
      "ignoredElements": "#ignoredElements",
      "keyCodes": "#keyCodes",
      "performance": "#performance@2.2",
      "productionTip": "#productionTip@2.2"
    }
  },
  "API": {
    "title": "Global",
    "url": "#全局-API",
    "sub": {
      "Vue.extend": "#Vue-extend",
      "Vue.nextTick": "#Vue-nextTick",
      "Vue.set": "#Vue-set",
      "Vue.delete": "#Vue-delete",
      "Vue.directive": "#Vue-directive",
      "Vue.filter": "#Vue-filter",
      "Vue.component": "#Vue-component",
      "Vue.use": "#Vue-use",
      "Vue.mixin": "#Vue-mixin",
      "Vue.compile": "#Vue-compile",
      "Vue.observable": "#Vue-observable@2.6",
      "Vue.version": "#Vue-version"
    }
  },
  "生命周期钩子": {
    "title": "Options",
    "url": "#选项-生命周期钩子",
    "sub": {
      "beforeCreate": "#beforeCreate",
      "created": "#created",
      "beforeMount": "#beforeMount",
      "mounted": "#mounted",
      "beforeUpdate": "#beforeUpdate",
      "updated": "#updated",
      "activated": "#activated",
      "deactivated": "#deactivated",
      "beforeDestroy": "#beforeDestroy",
      "destroyed": "#destroyed",
      "errorCaptured": '#errorCaptured@2.5'
    }
  },
  "数据 ": {
    "title": "Options",
    "url": "#选项-数据",
    "sub": {
      "data": "#data",
      "props": "#props",
      "propsData": "#propsData",
      "computed": "#computed",
      "methods": "#methods",
      "watch": "#watch"
    }
  },
  "DOM": {
    "title": "Options",
    "url": "#选项-DOM",
    "sub": {
      "el": "#el",
      "template": "#template",
      "render": "#render",
      "renderError": "#renderError@2.2"
    }
  },
  "资源": {
    "title": "Options",
    "url": "#选项-资源",
    "sub": {
      "directives": "#directives",
      "filters": "#filters",
      "components": "#components"
    }
  },
  "组合": {
    "title": "Options",
    "url": "#选项-组合",
    "sub": {
      "parent": "#parent",
      "mixins": "#mixins",
      "extends": "#extends",
      "provide / inject": "#provide-inject"
    }
  },
  "其他": {
    "title": "Options",
    "url": "#选项-其他",
    "sub": {
      "name": "#name",
      "delimiters": "#delimiters",
      "functional": "#functional",
      "model": "#model@2.2",
      "inheritAttrs": "#inheritAttrs@2.4",
      "comments": "#comments@2.4"
    }
  },
  "数据": {
    "title": "Methods",
    "url": "#实例方法-数据",
    "sub": {
      "vm.$watch": "#vm-watch",
      "vm.$set": "#vm-set",
      "vm.$delete": "#vm-delete",
    }
  },
  "事件": {
    "title": "Methods",
    "url": "#实例方法-事件",
    "sub": {
      "vm.$on": "#vm-on",
      "vm.$once": "#vm-once",
      "vm.$off": "#vm-off",
      "vm.$emit": "#vm-emit"
    }
  },
  "生命周期": {
    "title": "Methods",
    "url": "#实例方法-生命周期",
    "sub": {
      "vm.$mount": "#vm-mount",
      "vm.$forceUpdate": "#vm-forceUpdate",
      "vm.$nextTick": "#vm-nextTick",
      "vm.$destroy": "#vm-destroy"
    }
  },
  "实例属性": {
    "title": "Instance",
    "url": "#实例属性",
    "sub": {
      "vm.$data": "#vm-data",
      "vm.$props": "#vm-props@2.2",
      "vm.$el": "#vm-el",
      "vm.$options": "#vm-options",
      "vm.$parent": "#vm-parent",
      "vm.$root": "#vm-root",
      "vm.$children": "#vm-children",
      "vm.$slots": "#vm-slots",
      "vm.$scopedSlots": "#vm-scopedSlots@2.1",
      "vm.$refs": "#vm-refs",
      "vm.$isServer": "#vm-isServer",
      "vm.$attrs": "#vm-attrs@2.4",
      "vm.$listeners": "#vm-listeners@2.4"
    }
  },
  "指令": {
    "title": "html",
    "url": "#指令",
    "sub": {
      "v-text": "#v-text",
      "v-html": "#v-html",
      "v-show": "#v-show",
      "v-if": "#v-if",
      "v-else": "#v-else",
      "v-else-if": "#v-else-if@2.1",
      "v-for": "#v-for",
      "v-on": "#v-on",
      "v-bind": "#v-bind",
      "v-model": "#v-model",
      "v-slot": "#v-slot@2.6",
      "v-pre": "#v-pre",
      "v-cloak": "#v-cloak",
      "v-once": "#v-once"
    }
  },
  "钩子函数": {
    "title": "指令",
    "url": "#钩子函数",
    "sub": {
      "bind": "guide/custom-directive.html#钩子函数",
      "inserted": "guide/custom-directive.html#钩子函数",
      "update": "guide/custom-directive.html#钩子函数",
      "componentUpdated": "guide/custom-directive.html#钩子函数",
      "unbind": "guide/custom-directive.html#钩子函数"
    }
  },
  "特殊特性": {
    "title": "html",
    "url": "#特殊特性",
    "sub": {
      "key": "#key",
      "ref": "#ref",
      "is": "#is",
      "slot": "#slot@2.6废弃",
      "slot-scope": "#slot-scope@2.6废弃",
      "scope": "#scope-replaced@2.5移除"
    }
  },
  "组件": {
    "title": "内置",
    "url": "#内置的组件",
    "sub": {
      "component": "#component",
      "transition": "#transition",
      "transition-group": "#transition-group",
      "keep-alive": "#keep-alive",
      "slot": "#slot-1"
    }
  },
  "v-model": {
    "title": "Modifiers",
    "url": "#",
    "sub": {
      "<small>v-model</small> lazy": "guide/forms.html#lazy",
      "<small>v-model</small> number": "guide/forms.html#number",
      "<small>v-model</small> trim": "guide/forms.html#trim"
    }
  },
  "Event": {
    "title": "Modifiers",
    "url": "#",
    "sub": {
      "<small>v-on:click</small> .native": "guide/components-custom-events.html#将原生事件绑定到组件",
      "<small>v-on:click</small> .stop": "guide/events.html#事件修饰符",
      "<small>v-on:click</small> .prevent": "guide/events.html#事件修饰符",
      "<small>v-on:click</small> .capture": "guide/events.html#事件修饰符",
      "<small>v-on:click</small> .self": "guide/events.html#事件修饰符",
      "<small>v-on:click</small> .once": "guide/events.html#事件修饰符@2.1.4",
      "<small>v-on:click</small> .passive": "guide/events.html#事件修饰符@2.3"
    }
  },
  "v-bind": {
    "title": "Modifiers",
    "url": "#v-bind",
    "sub": {
      "<small>v-bind</small> .prop": "#v-bind",
      "<small>v-bind</small> .camel": "#v-bind@2.1",
      "<small>v-bind</small> .sync": "#v-bind@2.3",
    }
  },
  "Mouse": {
    "title": "Modifiers",
    "url": "guide/events.html#鼠标按钮修饰符",
    "sub": {
      "<small>v-on:click</small> .left": "guide/events.html#鼠标按钮修饰符@2.2",
      "<small>v-on:click</small> .right": "guide/events.html#鼠标按钮修饰符@2.2",
      "<small>v-on:click</small> .middle": "guide/events.html#鼠标按钮修饰符@2.2",
    }
  },
  "Keyboard": {
    "title": "Modifiers",
    "url": "guide/events.html#按键修饰符",
    "sub": {
      "<small>v-on:keyup</small> .enter": "guide/events.html#按键修饰符",
      "<small>v-on:keyup</small> .tab": "guide/events.html#按键修饰符",
      "<small>v-on:keyup</small> .delete": "guide/events.html#按键修饰符",
      "<small>v-on:keyup</small> .esc": "guide/events.html#按键修饰符",
      "<small>v-on:keyup</small> .space": "guide/events.html#按键修饰符",
      "<small>v-on:keyup</small> .up": "guide/events.html#按键修饰符",
      "<small>v-on:keyup</small> .down": "guide/events.html#按键修饰符",
      "<small>v-on:keyup</small> .left": "guide/events.html#按键修饰符",
      "<small>v-on:keyup</small> .right": "guide/events.html#按键修饰符",
      "<small>v-on:keyup</small> .key": "guide/events.html#自动匹配按键修饰符@2.5",
      "<small>v-on:keyup</small> .ctrl": "guide/events.html#系统修饰键@2.1",
      "<small>v-on:keyup</small> .alt": "guide/events.html#系统修饰键@2.1",
      "<small>v-on:keyup</small> .shift": "guide/events.html#系统修饰键@2.1",
      "<small>v-on:keyup</small> .meta": "guide/events.html#系统修饰键@2.1",
    }
  }
}
